import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { Entities } from 'src/enums'
import { SensorUpload } from 'src/api'
import { useApiInstance } from './useApiInstance'
import {
  buildRequestParams,
  ObjectType,
  transformPage,
  transformPerPage,
} from './helpers'

interface RequestParams {
  params?: Partial<AdminSensorUploadsGetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<
    UseQueryOptions<APIList<SensorUpload>, Error>,
    'queryKey' | 'queryFn'
  >;
}

interface AdminSensorUploadsGetParams {
  limit: number;
  offset: number;
  sort: string;
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  sort: 'string',
}

export const useSensorUploadListRequest = ({
  params = {},
  paramsTransform = [],
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [
    transformPerPage,
    transformPage,
    ...paramsTransform,
  ].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<AdminSensorUploadsGetParams>(
    transformedParams,
    schema,
  )

  return useQuery<APIList<SensorUpload>, Error>(
    [Entities.SensorUploads, JSON.stringify(transformedParams)],
    async () => {
      const { limit, offset, sort } = queryParams
      const { data } = await api.v1AdminSensorUploadsGet(limit, offset, sort)
      return data as unknown as APIList<SensorUpload>
    },
    {
      enabled: Object.keys(transformedParams).length > 0,
      ...options,
    },
  )
}
